
import { Editor } from '@tiptap/react';
import FormattingButtons from './FormattingButtons';
import HeadingButtons from './HeadingButtons';
import ListButtons from './ListButtons';
import BlockquoteButton from './BlockquoteButton';
import UndoRedoButtons from './UndoRedoButtons';
import LinkButton from './LinkButton';
import ImageButton from './ImageButton';
import MediaLibraryButton from './MediaLibraryButton';

interface EditorToolbarProps {
  editor: Editor;
  onImageUploadClick: () => void;
  openMediaLibrary: () => void;
  isUploading: boolean;
}

export default function EditorToolbar({
  editor,
  onImageUploadClick,
  openMediaLibrary,
  isUploading
}: EditorToolbarProps) {
  if (!editor) return null;

  return (
    <div className="flex flex-wrap gap-1 p-2 border-b border-white/10 bg-black/30">
      <FormattingButtons editor={editor} />
      <HeadingButtons editor={editor} />
      <ListButtons editor={editor} />
      <BlockquoteButton editor={editor} />
      <UndoRedoButtons editor={editor} />
      <div className="border-r border-white/10 mx-1 h-8"></div>
      <LinkButton editor={editor} />
      <ImageButton onImageUploadClick={onImageUploadClick} isUploading={isUploading} />
      <MediaLibraryButton openMediaLibrary={openMediaLibrary} />
    </div>
  );
}
